import { useAuthContextV2 } from "../../../auth-state";
import { MenuListV2 } from "@graffer-inc/console-design-kit";
import { SmartApplyR } from "../../pages/smart-apply/route";
import { useRBAC } from "../../helpers/rbac/use-rbac";
import { Link, useLocation } from "react-router-dom";
import { useFeatureFlag_EnableApplyAssignment } from "../../../feature-flags";

export const SmartApplyMenuList = () => {
  const { auth } = useAuthContextV2();
  const hasPermission = useRBAC();
  const location = useLocation();
  return (
    <MenuListV2.MenuList
      items={[
        {
          header: "申請",
          navItems: [
            {
              title: "申請一覧",
              anchor: ({ children, ...props }) => (
                <Link to={SmartApplyR.Applications.link({})} {...props}>
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.Applications.link({}),
              ),
              hidden: !hasPermission({
                requirePermissions: "applications.list",
              }),
              icon: "SmartapplyIcon",
            },
            {
              title: "振り分け申請一覧",
              anchor: ({ children, ...props }) => (
                <Link to={SmartApplyR.AssignedApplications.link({})} {...props}>
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.AssignedApplications.link({}),
              ),
              hidden:
                !useFeatureFlag_EnableApplyAssignment(auth.orgSlug) ||
                auth.groupIDs.length === 0 || // user に対して振り分けられるようになったら削除
                !hasPermission({
                  requirePermissions: "applications.list",
                }),
              icon: "SmartapplyIcon",
            },
            {
              title: "交付依頼一覧",
              anchor: ({ children, ...props }) => (
                <Link
                  to={SmartApplyR.QualifiedInvoiceIssueRequests.link({})}
                  {...props}
                >
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.QualifiedInvoiceIssueRequests.link({}),
              ),
              hidden:
                !hasPermission({
                  requirePermissions: "qualified_invoice_issue_request.list",
                }) ||
                (!auth.usePayment && !auth.usePaymentPayeasy),
              icon: "PaperIcon",
            },
            {
              title: "申請者レビュー",
              anchor: ({ children, ...props }) => (
                <Link to={SmartApplyR.CustomerReviews.link({})} {...props}>
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.CustomerReviews.link({}),
              ),
              hidden: !hasPermission({
                requirePermissions: "customer_reviews.list",
              }),
              icon: "CommentIcon",
            },
          ],
        },
        {
          header: "手続き",
          navItems: [
            {
              title: "手続き一覧",
              anchor: ({ children, ...props }) => (
                <Link to={SmartApplyR.Procedures.link({})} {...props}>
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.Procedures.link({}),
              ),
              hidden: !hasPermission({
                requirePermissions: "procedures.read",
              }),
              icon: "ListSettingIcon",
            },
            {
              title: "アーカイブ一覧",
              anchor: ({ children, ...props }) => (
                <Link to={SmartApplyR.ArchivedProcedures.link({})} {...props}>
                  {children}
                </Link>
              ),
              active: location.pathname.includes(
                SmartApplyR.ArchivedProcedures.link({}),
              ),
              hidden: !hasPermission({
                requirePermissions: "procedures.read",
              }),
              icon: "ListSettingIcon",
            },
          ],
        },
      ]}
    />
  );
};
